// Shared by ElectronPlatform and BrowserPlatform so the http(s)-only rule for
// openExternalUrl is checked in one place rather than duplicated, divergently, in two
// classes. The main process repeats this same check as defense in depth.
export function isOpenableUrl(value) {
    if (typeof value !== 'string') {
        return false
    }
    try {
        const { protocol } = new URL(value)
        return protocol === 'http:' || protocol === 'https:'
    }
    catch {
        return false
    }
}
